// src/components/SitemapPage.js
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { getSitemap } from '../services/api';
import DisclaimerLink from './DisclaimerLink';

function SitemapPage() {
  const [sitemap, setSitemap] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    getSitemap()
      .then((xml) => setSitemap(xml))
      .catch((err) => setError('Failed to load sitemap'));
  }, []);

  if (error) return <div>{error}</div>;
  if (!sitemap) return <div>Loading sitemap...</div>;

  return (
    <>
      <Helmet>
        <title>Sitemap - Blue Compass RV Technical Support</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
    <div style={{ padding: '20px' }}>
      <p style={{ marginBottom: '20px' }}>
        <DisclaimerLink />
      </p>
      <h1>Sitemap</h1>
      <pre>{sitemap}</pre>
    </div>
    </>
  );
}

export default SitemapPage;